export default __webpack_public_path__ + "static/media/groups.a0750e4d.svg";